export default "/images/3f148506f46c43d78d1e8997dced1784.avif";